import React from 'react';
import { useProjectContext } from '../../hooks/useProjectContext';
import { Calendar, CheckCircle2, AlertCircle, Clock, Globe } from 'lucide-react';
export function SprintContextBar() {
  const {
    activeProject,
    isGlobalView,
    projects
  } = useProjectContext();
  const safeProjects = Array.isArray(projects) ? projects : [];
  if (isGlobalView) {
    const totalInProgress = safeProjects.reduce((s, p) => s + (Array.isArray(p.issues) ? p.issues.filter(i => i.status === 'In Progress').length : 0), 0);
    const totalDone = safeProjects.reduce((s, p) => s + (Array.isArray(p.issues) ? p.issues.filter(i => i.status === 'Done').length : 0), 0);
    const avgProgress = safeProjects.length > 0 ? Math.round(safeProjects.reduce((s, p) => s + (p.sprint?.progress || 0), 0) / safeProjects.length) : 0;
    return <div className="px-6 py-2.5 bg-slate-900/80 border-b border-slate-800 flex items-center gap-6 text-xs backdrop-blur-sm" data-id="element-2746">
        <div className="flex items-center gap-2 shrink-0" data-id="element-2747">
          <Globe size={12} className="text-slate-400" data-id="element-2748" />
          <span className="font-semibold text-slate-300" data-id="element-2749">
            Vista Global · {safeProjects.length} proyectos
          </span>
        </div>
        <div className="h-3 w-px bg-slate-700" data-id="element-2750"></div>
        <span className="flex items-center gap-1 text-blue-400" data-id="element-2751">
          <Clock size={11} data-id="element-2752" />
          {totalInProgress} en progreso
        </span>
        <span className="flex items-center gap-1 text-emerald-400" data-id="element-2753">
          <CheckCircle2 size={11} data-id="element-2754" />
          {totalDone} completados
        </span>
        <div className="ml-auto text-slate-500 shrink-0" data-id="element-2755">
          Progreso promedio:{' '}
          <span className="text-slate-300 font-semibold" data-id="element-2756">{avgProgress}%</span>
        </div>
      </div>;
  }
  const sprint = activeProject?.sprint || {
    name: 'Sin sprint',
    progress: 0,
    endDate: new Date().toISOString(),
    completedPoints: 0,
    totalPoints: 0
  };
  const projectIssues = Array.isArray(activeProject?.issues) ? activeProject.issues : [];
  const inProgress = projectIssues.filter(i => i.status === 'In Progress').length;
  const done = projectIssues.filter(i => i.status === 'Done').length;
  const blockers = projectIssues.filter(i => i.priority === 'High' && i.status === 'To Do').length;
  const end = new Date(sprint.endDate);
  const today = new Date();
  const daysLeft = Math.max(0, Math.ceil((end.getTime() - today.getTime()) / (1000 * 60 * 60 * 24)));
  return <div className="px-6 py-2.5 bg-slate-900/80 border-b border-slate-800 flex items-center gap-6 text-xs backdrop-blur-sm" data-id="element-2757">
      {/* Project badge + sprint */}
      <div className="flex items-center gap-2 shrink-0" data-id="element-2758">
        <div className={`w-4 h-4 rounded ${activeProject.color} flex items-center justify-center text-white text-[8px] font-bold`} data-id="element-2759">
          {activeProject.key.slice(0, 1)}
        </div>
        <div className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" data-id="element-2760"></div>
        <span className="font-semibold text-slate-300" data-id="element-2761">{sprint.name}</span>
      </div>

      <div className="h-3 w-px bg-slate-700" data-id="element-2762"></div>

      <div className="flex items-center gap-2 shrink-0" data-id="element-2763">
        <div className="w-20 h-1.5 bg-slate-700 rounded-full overflow-hidden" data-id="element-2764">
          <div className="h-full bg-indigo-500 rounded-full transition-all" style={{
          width: `${sprint.progress}%`
        }} data-id="element-2765" />
        </div>
        <span className="text-slate-400" data-id="element-2766">{sprint.progress}%</span>
      </div>

      <div className="h-3 w-px bg-slate-700" data-id="element-2767"></div>

      <div className="flex items-center gap-4" data-id="element-2768">
        <span className="flex items-center gap-1 text-blue-400" data-id="element-2769">
          <Clock size={11} data-id="element-2770" />
          {inProgress} en progreso
        </span>
        <span className="flex items-center gap-1 text-emerald-400" data-id="element-2771">
          <CheckCircle2 size={11} data-id="element-2772" />
          {done} completados
        </span>
        {blockers > 0 && <span className="flex items-center gap-1 text-red-400" data-id="element-2773">
            <AlertCircle size={11} data-id="element-2774" />
            {blockers} bloqueadores
          </span>}
      </div>

      <div className="h-3 w-px bg-slate-700" data-id="element-2775"></div>

      <div className="flex items-center gap-1.5 text-slate-400 shrink-0" data-id="element-2776">
        <Calendar size={11} data-id="element-2777" />
        {daysLeft > 0 ? <>
            <span className={`font-semibold ${daysLeft <= 2 ? 'text-amber-400' : 'text-slate-300'}`} data-id="element-2778">
              {daysLeft}d
            </span>{' '}
            restantes
          </> : <span className="text-red-400 font-semibold" data-id="element-2779">Sprint vencido</span>}
      </div>

      <div className="ml-auto text-slate-500 shrink-0" data-id="element-2780">
        {sprint.completedPoints}/{sprint.totalPoints} pts
      </div>
    </div>;
}